<template>
  <v-col
    cols="12"
    class="d-flex align-center justify-center fill-height"
    style="background-color: #EEEEEE;"
  >
    <v-toolbar class="elevation-0 transparent">
      <v-spacer></v-spacer>
      <v-progress-circular
        indeterminate
        color="secondary"
      ></v-progress-circular>
      <v-spacer></v-spacer>
    </v-toolbar>
  </v-col>
</template>
<script>
import { mapGetters } from 'vuex'

export default {
  name: 'Chat',
  data() {
    return {
      nameFromUrl: this.$route.query.name,
      emailFromUrl: this.$route.query.email,
      phoneFromUrl: this.$route.query.phone,
      idFromUrl: this.$route.query.id,
      regionFromUrl: this.$route.query.region,
      languageFromUrl: this.$route.query.language,
      tawkToChatUrlsFromUrl: this.$route.query.tawkToChatUrls,
      tawkToHMAC: undefined,
      tawkLoaded: false
    }
  },
  watch: {
    tawkLoaded(newValue) {
      if (newValue === true) {
        this.initiateChat()
      }
    }
  },
  computed: {
    ...mapGetters('authentication', ['user'])
  },
  // beforeRouteLeave() {
  //   // eslint-disable-next-line no-useless-return
  //   this.preventDefault()
  // },
  async mounted() {
    const self = this
    // const languageEntityMapping = {
    //   EST: 'https://embed.tawk.to/5ff2f9b1df060f156a9441b2/1er6huo28',
    //   LTU: 'https://embed.tawk.to/601d55e1a9a34e36b9743059/1etp9eund'
    // }
    const enabledLanguageChatUrls = []
    let currentLanguageChatUrl
    let defaulLanguagetChatUrl
    const chatLanguages = JSON.parse(this.tawkToChatUrlsFromUrl)
    if (chatLanguages.length) {
      chatLanguages.forEach(chatUrl => {
        // Only 1 default can be in the chatLanguages
        if (chatUrl.default) {
          defaulLanguagetChatUrl = chatUrl
        }
        if (chatUrl.enabled === 'true') {
          enabledLanguageChatUrls.push(chatUrl)
        }
        if (
          this.languageFromUrl &&
          this.languageFromUrl !== '' &&
          chatUrl.enabled === 'true' &&
          chatUrl.language === this.languageFromUrl
        ) {
          currentLanguageChatUrl = chatUrl
        }
      })
    }
    if (!currentLanguageChatUrl) {
      currentLanguageChatUrl = defaulLanguagetChatUrl
    }

    if (currentLanguageChatUrl && currentLanguageChatUrl.url !== '') {
      this.$loadScript(currentLanguageChatUrl.url)
        .then(function() {
          self.tawkLoaded = true
          window.Tawk_API = window.$_Tawk
        })
        .catch(function() {
          self.tawkLoaded = false
        })
    }
  },
  methods: {
    changeURL() {
      const route = this.$route
      if (Object.keys(route.query).includes(this.query)) {
        this.queryPush = { ...route.query }
        delete this.queryPush[this.query]
        this.$router.push({ path: '/chat' })
      } else {
        this.queryPush = { [this.query]: this.value }
        this.$router.push({ path: '/chat' })
      }
    },
    async initiateChat() {
      this.nameFromUrl = this.$route.query.name
      this.emailFromUrl = this.$route.query.email
      this.phoneFromUrl = this.$route.query.phone
      this.idFromUrl = this.$route.query.id
      this.regionFromUrl = this.$route.query.region
      this.languageFromUrl = this.$route.query.language
      this.tawkToChatUrlsFromUrl = this.$route.query.tawkToChatUrls
      // TODO:: Enable if secure mode ready
      // if (this.emailFromUrl) {
      //   await fetch(
      //     `https://admin.barking.ee/admin/tawkto/hmac?email=${this.emailFromUrl}`
      //   )
      //     .then(response => response.text())
      //     .then(signature => {
      //       this.tawkToHMAC = signature
      //       if (this.$route.query) {
      //         this.changeURL()
      //       }
      //     })
      // }

      window.Tawk_API.visitor = {
        name: `${this.nameFromUrl || ''} ${this.idFromUrl ? '-' : ''} ${this
          .idFromUrl || ''} ${this.phoneFromUrl ? '-' : ''} ${this
          .phoneFromUrl || ''}`,
        email: this.emailFromUrl
        // hash: this.tawkToHMAC
      }
      window.Tawk_API.onOfflineSubmit = function(data) {
        const customerEmail = data.email
        const customerName = data.name
        const message = `Name: ${customerName ||
          'Unknown'},\nEmail: ${customerEmail || 'Unknown'},\nMessage: ${
          data.questions[3].answer
        }`
        const objectForSlack = { text: message }
        fetch(
          'https://hooks.slack.com/services/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',
          {
            method: 'POST',
            body: JSON.stringify(objectForSlack)
          }
        )
      }

      // const self = this

      window.Tawk_API.onChatMinimized = function() {
        window.Tawk_API.maximize()
      }
      window.Tawk_API.onLoad = function() {
        window.Tawk_API.hideWidget()
        if (window.Tawk_API.onLoaded) {
          // if (window.Tawk_API.visitor) {
          //   window.Tawk_API.setAttributes(window.Tawk_API.visitor)
          // }
          window.Tawk_API.showWidget()
          window.Tawk_API.maximize()
          // if (window.Tawk_API.isChatMaximized()) {
          //   self.$router.push({ path: '/chat' }).catch(() => {})
          // }
        }
      }
    }
  }
}
</script>
